// extracted by mini-css-extract-plugin
export var disabled = "_t-a";
export var hierarchyLinkGray = "_t-4";
export var hierarchyLinkUnderline = "_t-3";
export var hierarchyPrimary = "_t-0";
export var hierarchySecondary = "_t-1";
export var hierarchyTertiary = "_t-2";
export var pressed = "_t-6";
export var themeAction = "_t-5";
export var themeDestructive = "_t-8";
export var themeNormal = "_t-7";
export var themeSuccess = "_t-9";